// extracted by mini-css-extract-plugin
export default {"truncated_box":"truncated-box_truncated_box__jTWJI","disable_truncating":"truncated-box_disable_truncating__k+MGy"};